export { SightOverlay, type SightOverlayProps } from './SightOverlay';
